module.exports = __webpack_public_path__ + "res/img_info_b.5fbd19ca7359f2e9580d336af3bd2b4b.png";